import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-6539">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-6540">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-6541">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-6542">
            <ArrowLeft className="w-4 h-4" data-id="element-6543" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-6544">NOIZA</div>
          <div className="w-20" data-id="element-6545" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-6546">
        <div className="mb-12" data-id="element-6547">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-6548">
            <FileText className="w-6 h-6 text-white/80" data-id="element-6549" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-6550">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-6551">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-6552">
          <section data-id="element-6553">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6554">
              <span className="text-[#006847]" data-id="element-6555">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6556">
              <p data-id="element-6557">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-6558">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6559">
                <li data-id="element-6560">Haber leído íntegramente este documento</li>
                <li data-id="element-6561">Comprender su contenido en su totalidad</li>
                <li data-id="element-6562">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-6563">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-6564">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6565">
              <span className="text-[#006847]" data-id="element-6566">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6567">
              <p data-id="element-6568">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6569">
                <li data-id="element-6570">Software como servicio (SaaS)</li>
                <li data-id="element-6571">Marketplace digital gastronómico</li>
                <li data-id="element-6572">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-6573">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6574">
                <li data-id="element-6575">Mostrar su menú digital</li>
                <li data-id="element-6576">Recibir pedidos de clientes</li>
                <li data-id="element-6577">Gestionar su operación interna</li>
                <li data-id="element-6578">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-6579">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-6580">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6581">
              <span className="text-[#006847]" data-id="element-6582">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6583">
              <p data-id="element-6584">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6585">
                <li data-id="element-6586">No es proveedor de alimentos</li>
                <li data-id="element-6587">No participa en la preparación de productos</li>
                <li data-id="element-6588">No manipula alimentos en ningún momento</li>
                <li data-id="element-6589">No realiza entregas ni logística</li>
                <li data-id="element-6590">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-6591">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-6592">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-6593">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6594">
              <span className="text-[#006847]" data-id="element-6595">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-6596">
              <p data-id="element-6597">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-6598">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6599">
                <li data-id="element-6600">El restaurante es el único responsable de su operación</li>
                <li data-id="element-6601">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-6602">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-6603">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6604">
                <li data-id="element-6605">Precios</li>
                <li data-id="element-6606">Menú</li>
                <li data-id="element-6607">Horarios</li>
                <li data-id="element-6608">Métodos de pago</li>
                <li data-id="element-6609">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6610">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6611">
              <span className="text-[#006847]" data-id="element-6612">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-6613">
              <div data-id="element-6614">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6615">
                  5.1. Alcance general
                </h3>
                <p data-id="element-6616">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-6617">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6618">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-6619">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6620">
                  <li data-id="element-6621">Calidad de los alimentos</li>
                  <li data-id="element-6622">Estado, frescura o preparación</li>
                  <li data-id="element-6623">Ingredientes utilizados</li>
                  <li data-id="element-6624">Contaminación cruzada</li>
                  <li data-id="element-6625">Problemas de higiene o salubridad</li>
                  <li data-id="element-6626">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6627">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-6628">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6629">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-6630">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6631">
                  <li data-id="element-6632">Retrasos en la entrega</li>
                  <li data-id="element-6633">Pérdida de pedidos</li>
                  <li data-id="element-6634">Entregas incompletas</li>
                  <li data-id="element-6635">Errores en dirección</li>
                  <li data-id="element-6636">Conducta de repartidores</li>
                  <li data-id="element-6637">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-6638">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6639">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-6640">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-6641">
                  <li data-id="element-6642">Recepción de pagos</li>
                  <li data-id="element-6643">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-6644">Manejo de efectivo</li>
                  <li data-id="element-6645">Confirmación de pagos</li>
                  <li data-id="element-6646">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-6647">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6648">
                  <li data-id="element-6649">Pagos no recibidos</li>
                  <li data-id="element-6650">Comprobantes falsos</li>
                  <li data-id="element-6651">Errores en montos</li>
                  <li data-id="element-6652">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-6653">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6654">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-6655">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6656">
                  <li data-id="element-6657">Reclamos de clientes</li>
                  <li data-id="element-6658">Reembolsos</li>
                  <li data-id="element-6659">Cancelaciones</li>
                  <li data-id="element-6660">Disputas</li>
                  <li data-id="element-6661">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6662">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-6663">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6664">
              <span className="text-[#006847]" data-id="element-6665">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-6666">
              <p data-id="element-6667">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6668">
                <li data-id="element-6669">Responsable</li>
                <li data-id="element-6670">Legal</li>
                <li data-id="element-6671">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-6672">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6673">
                <li data-id="element-6674">Publicar información falsa</li>
                <li data-id="element-6675">Manipular precios de forma engañosa</li>
                <li data-id="element-6676">Simular disponibilidad inexistente</li>
                <li data-id="element-6677">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6678">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6679">
              <span className="text-[#006847]" data-id="element-6680">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-6681">
              <p data-id="element-6682">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6683">
                <li data-id="element-6684">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-6685">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-6686">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6687">
                <li data-id="element-6688">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-6689">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-6690">
                    <li data-id="element-6691">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-6692">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-6693">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6694">
              <span className="text-[#006847]" data-id="element-6695">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-6696">
              <p data-id="element-6697">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6698">
                <li data-id="element-6699">Menú digital</li>
                <li data-id="element-6700">Gestión de pedidos</li>
                <li data-id="element-6701">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-6702">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6703">
                  <p className="font-medium text-white mb-2" data-id="element-6704">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6705">
                    <li data-id="element-6706">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6707">
                  <p className="font-medium text-white mb-2" data-id="element-6708">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6709">
                    <li data-id="element-6710">Propiedad del software</li>
                    <li data-id="element-6711">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-6712">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-6713">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6714">
              <span className="text-[#006847]" data-id="element-6715">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6716">
              <p data-id="element-6717">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6718">
                <li data-id="element-6719">Disponibilidad continua</li>
                <li data-id="element-6720">Funcionamiento sin interrupciones</li>
                <li data-id="element-6721">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-6722">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6723">
                <li data-id="element-6724">Fallas técnicas</li>
                <li data-id="element-6725">Actualizaciones</li>
                <li data-id="element-6726">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-6727">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-6728">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6729">
              <span className="text-[#006847]" data-id="element-6730">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-6731">
              <p data-id="element-6732">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6733">
                <li data-id="element-6734">No está garantizada permanentemente</li>
                <li data-id="element-6735">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-6736">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6737">
                <li data-id="element-6738">Destacar o no restaurantes</li>
                <li data-id="element-6739">Modificar posiciones</li>
                <li data-id="element-6740">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6741">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6742">
              <span className="text-[#006847]" data-id="element-6743">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-6744">
              <p data-id="element-6745">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6746">
                <li data-id="element-6747">Cumplir con los pagos acordados</li>
                <li data-id="element-6748">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-6749">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6750">
                <li data-id="element-6751">Suspender el servicio</li>
                <li data-id="element-6752">Limitar funcionalidades</li>
                <li data-id="element-6753">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6754">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6755">
              <span className="text-[#006847]" data-id="element-6756">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6757">
              <p data-id="element-6758">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6759">
                <li data-id="element-6760">Incumplimiento de términos</li>
                <li data-id="element-6761">Uso indebido</li>
                <li data-id="element-6762">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-6763">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-6764">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6765">
              <span className="text-[#006847]" data-id="element-6766">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-6767">
              <p data-id="element-6768">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-6769">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-6770">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6771">
              <span className="text-[#006847]" data-id="element-6772">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-6773">
              <p data-id="element-6774">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6775">
                <li data-id="element-6776">Pérdidas económicas</li>
                <li data-id="element-6777">Daños indirectos</li>
                <li data-id="element-6778">Lucro cesante</li>
                <li data-id="element-6779">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6780">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6781">
              <span className="text-[#006847]" data-id="element-6782">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-6783">
              <p data-id="element-6784">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-6785">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6786">
              <span className="text-[#006847]" data-id="element-6787">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-6788">
              <p className="font-medium" data-id="element-6789">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-6790">
                <li data-id="element-6791">Ha leído este documento completo</li>
                <li data-id="element-6792">Comprende su alcance</li>
                <li data-id="element-6793">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}